module.exports = __webpack_public_path__ + "static/iski-1-59fb70ba10af402c0ed2960a44b26b4d.png";